// Address of the wallet that receives payments on the Base Mainnet
export const PAYMENT_RECEIVER_ADDRESS = '0x3B8b6D1D526885e087B4A32eb1FF08E6EdB01CD8';

// List of whitelisted wallet addresses
export const WHITELISTED_WALLETS: string[] = [
  '0x9726bed3D2e3b4b6221d4Eec4F35Ea22b7198f57',  // Peut être en majuscules ou minuscules
  '0x5aA79D40a9d0ad34883894bD75772D4e2B3bD21E', // Nev
  '0xf38a073B4B64C67529F9aEF5B0c53C475e991EA0', //personnal test
  '0x34a124b036c3963b15948b8e8be0dfae05e914ae', // Mechsicko -Regen-
  '0x8D4710718b41A673f64A189c6C7809Ee04CE6FF0', // Kidra on X
  '0x025E03A90607F6F9DE7d9F80a48B7ceA77f37C6f', // Ming-Merciless on X
  '0x9d5E68962582Bdd16aA2E6Ec9E1dcDBC1e4eaf10', // Monkeytown X
  '0x5cB7591f6660C041EdB7A4e6104aa86384Bea066', // Nahid X
  '0xBF25b9E52A03DB7887881d55aB9c2909F698FC69', //eazy X
  // Ajoutez d'autres adresses selon vos besoins
];

// Network configuration
export const NETWORK_CONFIG = {
  chainId: '0x2105', // Hexadecimal Base Mainnet Chain ID
  chainName: 'Base',
  nativeCurrency: {
    name: 'ETH',
    symbol: 'ETH',
    decimals: 18
  },
  rpcUrls: ['https://mainnet.base.org'],
  blockExplorerUrls: ['https://basescan.org']
}; 
